export const languageText = "en";
export const ApiURL = getEnvironment();

function getEnvironment() {
  let ApiURL;
  if (window.location.hostname.includes("localhost")) {
    ApiURL = "http://localhost/apicalls";
  } else {
    ApiURL = "https://www.beachatpalmpavilioninn.com/apicalls";
  }
  return ApiURL;
}
